// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__B0B-k"};